/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type TextLanguageFieldFieldValue =
  (typeof TextLanguageFieldFieldValue)[keyof typeof TextLanguageFieldFieldValue];

export const TextLanguageFieldFieldValue = {
  english: 'english',
  spanish: 'spanish',
  french: 'french',
  german: 'german',
  italian: 'italian',
  portuguese: 'portuguese',
  russian: 'russian',
  japanese: 'japanese',
  chinese: 'chinese',
  arabic: 'arabic',
  hindi: 'hindi',
  bengali: 'bengali',
  urdu: 'urdu',
  korean: 'korean',
  turkish: 'turkish',
  vietnamese: 'vietnamese',
  polish: 'polish',
  ukrainian: 'ukrainian',
  dutch: 'dutch',
  romanian: 'romanian',
  greek: 'greek',
  czech: 'czech',
  swedish: 'swedish',
  hungarian: 'hungarian',
  finnish: 'finnish',
  thai: 'thai',
  hebrew: 'hebrew',
  indonesian: 'indonesian',
  norwegian: 'norwegian',
  danish: 'danish',
  slovak: 'slovak',
  croatian: 'croatian',
  serbian: 'serbian',
  persian: 'persian',
  malay: 'malay',
  filipino: 'filipino',
  swahili: 'swahili',
  tamil: 'tamil',
  telugu: 'telugu',
  marathi: 'marathi',
  punjabi: 'punjabi',
  gujarati: 'gujarati',
  malayalam: 'malayalam',
  burmese: 'burmese',
  khmer: 'khmer',
  lao: 'lao',
  nepali: 'nepali',
  georgian: 'georgian',
  armenian: 'armenian',
  estonian: 'estonian',
} as const;
